import React from "react";
import "./HomePage.css";

function HomePage() {
  return (
    <div className="home-container">
      <h1 className="home-title">Frequenze di Saggezza</h1>
      <p className="home-subtitle">Coltiva la saggezza. Trasforma la tua vita.</p>
      <div className="home-content">
        <p>
          Benvenuto su Frequenze di Saggezza, il tuo spazio dedicato alla riflessione, alla crescita personale e alla scoperta di insegnamenti universali per una vita piena di significato. 
          Qui esploriamo la saggezza in tutte le sue forme: dall’antica filosofia alla psicologia moderna, dalle pratiche spirituali agli strumenti pratici per affrontare le sfide quotidiane con equilibrio e consapevolezza.
        </p>
        <h2>Chi Siamo</h2>
        <p>
          Siamo un punto d’incontro per chi cerca ispirazione e crescita interiore. Crediamo che la saggezza, in ogni sua espressione, sia una guida fondamentale per vivere una vita più autentica, felice e connessa ai propri valori.
        </p>
        <h2>Cosa Troverai su Questo Sito</h2>
        <ul>
          <li><strong>Articoli e Guide:</strong> Approfondimenti su filosofia, psicologia, spiritualità e crescita personale.</li>
          <li><strong>Video Ispirazionali:</strong> Contenuti per riflettere e ritrovare la tua forza interiore.</li>
          <li><strong>Podcast di Saggezza:</strong> Conversazioni profonde e pratiche per nutrire mente e anima.</li>
          <li><strong>Strumenti Pratici:</strong> Tecniche e esercizi per migliorare la tua resilienza, calma e consapevolezza.</li>
        </ul>
        <h2>I Nostri Pilastri</h2>
        <ol>
          <li><strong>Filosofie senza tempo:</strong> Dallo Stoicismo al Buddhismo, esploriamo le tradizioni che hanno guidato l’umanità.</li>
          <li><strong>Saggezza moderna:</strong> Idee contemporanee che uniscono scienza e spiritualità per aiutarti a vivere al meglio.</li>
          <li><strong>Praticità quotidiana:</strong> Risorse semplici e concrete per portare più equilibrio e chiarezza nella tua giornata.</li>
        </ol>
        <h2>Perché Sceglierci?</h2>
        <p>
          In un mondo pieno di rumore e distrazioni, Frequenze di Saggezza ti offre una guida per ritrovare serenità e centratura. 
          Che tu stia cercando motivazione, ispirazione o strumenti pratici, siamo qui per aiutarti a trasformare ogni momento in un’opportunità di crescita.
        </p>
        <h2>Unisciti a Noi</h2>
        <p>
          Non limitarti a esistere, impara a vivere con intenzione. Esplora il nostro universo di contenuti e inizia oggi il tuo percorso verso la saggezza.
        </p>
        <div className="home-buttons">
          <a
            href="https://www.youtube.com/channel/@FrequenzediSaggezzaStoica"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon youtube"
          >
            <i className="fab fa-youtube"></i>
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61571814955253"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon facebook"
          >
            <i className="fab fa-facebook"></i>
          </a>
          <a
            href="https://www.tiktok.com/@frequenze.di.sagg?_t=ZG-8t0SyheQS9p&_r=1"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon tiktok"
          >
            <i className="fab fa-tiktok"></i>
          </a>
        </div>
      </div>
    </div>
  );
}

export default HomePage;